import { AwsRum, AwsRumConfig } from "aws-rum-web";

export let awsRum: AwsRum | null = null;

export function initializeRum(): AwsRum | null {
  try {
    // Get configuration from environment variables
    const appMonitorId = import.meta.env.VITE_RUM_APP_MONITOR_ID;
    const identityPoolId = import.meta.env.VITE_RUM_IDENTITY_POOL_ID;
    const region = import.meta.env.VITE_RUM_REGION;

    // Validate required environment variables
    if (!appMonitorId || !identityPoolId || !region) {
      console.warn("CloudWatch RUM: Missing required environment variables");
      return null;
    }

    const config: AwsRumConfig = {
      allowCookies: true,
      endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
      identityPoolId: identityPoolId,
      sessionSampleRate: 1,
      telemetries: [
        "errors",
        "performance",
        [
          "http",
          {
            addXRayTraceIdHeader: [
              /internal\.api\.test\.rpiprint\.com/,
              /internal\.api\.sandbox\.rpiprint\.com/,
              /internal\.api\.rpiprint\.com/,
            ],
          },
        ],
      ],
      disableAutoPageView: true, // We manually record page views
      enableXRay: true,
    };

    const APPLICATION_VERSION = "1.0.0";

    awsRum = new AwsRum(appMonitorId, APPLICATION_VERSION, region, config);

    console.log("CloudWatch RUM initialized successfully");
    return awsRum;
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.warn("CloudWatch RUM initialization failed:", error);
    return null;
  }
}
